import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeparateIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m3 8 5 3v6l-5-3zM16 5l5 3v6l-5 3-5-3V8z" }), /* @__PURE__ */ _jsx("path", {
		d: "M10 12h3M11.5 10.5 13 12l-1.5 1.5",
		opacity: .4
	})]
});
export default SvgSeparateIcon;
